import React from 'react';

import green from '@material-ui/core/colors/green';
import { makeStyles } from '@material-ui/core/styles';
import Switch, { SwitchProps } from '@material-ui/core/Switch';

export const defaultStyle = makeStyles(() => ({
  switchBase: {
    color: 'white',
    '&$checked': {
      color: green[500],
    },
    '&$checked + $track': {
      backgroundColor: green[500],
    },
  },
  checked: {},
  track: {},
}));

// IF (06/15/20): Pulled from https://material-ui.com/components/switches/#CustomizedSwitches.js
const smallStyle = makeStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 2,
    color: theme.palette.common.white,
    '&$checked': {
      transform: 'translateX(12px)',
      color: green[500],
      '& + $track': {
        backgroundColor: green[500],
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  track: {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.grey[500],
  },
  checked: {},
}));

export const UiGreenSwitch = (props: SwitchProps) => {
  const classes = props.size === 'small' ? smallStyle() : defaultStyle();
  const propsToForward = { ...props };
  delete propsToForward.size;

  return <Switch {...propsToForward} classes={classes} />;
};
